// src/components/book/BookCard.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../hooks/useCart';
import { useWishlist } from '../../contexts/WishlistContext';
import { useReviews } from '../../contexts/ReviewContext'; // ← Added
import StarRating from 'react-stars';
import '../../styles/book/BookCard.css';

const BookCard = ({ book }) => {
  const { addToCart } = useCart();
  const { wishlist, addToWishlist, removeFromWishlist, isWishlisted } = useWishlist();
  const { getReviews, loadReviews } = useReviews();

  const [wishlisted, setWishlisted] = useState(false);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    setWishlisted(isWishlisted(book.id));
  }, [wishlist, book.id, isWishlisted]);

  // Load reviews for this book
  useEffect(() => {
    loadReviews(book.id).then(loadedReviews => {
      setReviews(loadedReviews || []);
    });
  }, [book.id, loadReviews]);

  const toggleWishlist = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (wishlisted) removeFromWishlist(book.id);
    else addToWishlist(book);
    setWishlisted(!wishlisted);
  };

  // Calculate real average rating and count
  const reviewCount = reviews.length;
  const averageRating = reviewCount > 0
    ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviewCount).toFixed(1)
    : null;

  return (
    <div className="book-card">
      <Link to={`/book/${book.id}`} className="book-card-cover-link">
        <div className="book-card-cover">
          <img
            src={book.imageUrl || '/placeholder-book.jpg'}
            alt={book.title}
            className="book-card-image"
          />
          <div
            className={`wishlist-icon ${wishlisted ? 'active' : ''}`}
            onClick={toggleWishlist}
          >
            ♥
          </div>
          <div className="book-card-overlay">
            <span className="overlay-text">View Details</span>
          </div>
        </div>
      </Link>

      <div className="book-card-info">
        <Link to={`/book/${book.id}`} className="book-card-title-link">
          <h3 className="book-card-title">{book.title}</h3>
        </Link>
        <p className="book-card-author">by {book.author}</p>

        {/* Real Rating from Reviews */}
        <div className="book-card-rating">
          {averageRating ? (
            <>
              <StarRating
                value={parseFloat(averageRating)}
                edit={false}
                size={18}
                color2="#D9A441"
              />
              <span className="rating-number">
                {averageRating} ({reviewCount} {reviewCount === 1 ? 'review' : 'reviews'})
              </span>
            </>
          ) : (
            <span className="no-reviews">No reviews yet</span>
          )}
        </div>

        <p className="book-card-price">${book.price?.toFixed(2)} CAD</p>

        <button onClick={() => addToCart(book)} className="book-card-add-btn">
          Add to Cart
        </button>
      </div>
    </div>
  );
};

export default BookCard;